// removed by extract-text-webpack-plugin
module.exports = {"label":"kr_g8 _3HxmGPYHMtOjs3AwT25mSa","button":"kr_bp _1kB_d9laDuyaX1azPOvneD","bar":"kr_ks","barTransparent":"kr_kt kr_ks"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/HeaderMenu/components/HeaderMenuButton/styles.module.css
// module id = 1078
// module chunks = 27